export default __webpack_public_path__ + "static/media/samsung-logo.781be0da.png";